import httpClient from '@/utils/httpClient'
import type { QuestionConfiguration } from '../types'

const questionConfigurationsService = {
  fetchQuestionConfigurations: async (templateId: string): Promise<Record<string, QuestionConfiguration>> => {
    const response = await httpClient.get<QuestionConfiguration[]>(`/v1/templates/${templateId}/questions/configurations`)
    const questionConfigurations: Record<string, QuestionConfiguration> = {}
    response.data.forEach(questionConfiguration => {
      questionConfigurations[questionConfiguration.question_code] = questionConfiguration
    })
    return questionConfigurations
  },
}

export default questionConfigurationsService
